import type { OnboardingStatus } from '@/app/api/onboarding/status/types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export const onboardingStatusQueryKey = (installationId: number | null) => [
  'onboarding-status',
  installationId,
];

export function useOnboardingStatus(installationId: number | null) {
  return useQuery<OnboardingStatus>({
    queryKey: onboardingStatusQueryKey(installationId),
    queryFn: async ({ signal }) => {
      if (!installationId) {
        throw new Error('Installation ID is required');
      }

      const params = new URLSearchParams({
        installationId: installationId.toString(),
      });

      const response = await fetch(`/api/onboarding/status?${params.toString()}`, {
        signal,
      });

      if (!response.ok) {
        throw new Error('Failed to fetch onboarding status');
      }

      return response.json();
    },
    enabled: !!installationId,
    // Keep the previous installation's status while switching installations so
    // the Getting Started card doesn't unmount and remount mid-switch. Only
    // while a fetch is possible: a disabled query (no installation) must not
    // keep showing the previous installation's data indefinitely.
    placeholderData: installationId ? keepPreviousData : undefined,
  });
}
